import { useEffect, useState } from 'react';
import { RudderAnalytics } from '@rudderstack/analytics-js';

const useRudderStackAnalytics = (): RudderAnalytics | undefined => {
  const [analytics, setAnalytics] = useState<RudderAnalytics>();

  useEffect(() => {
    if (!analytics) {
      const analyticsInstance = new RudderAnalytics();
      analyticsInstance.load('2pcJLUXpW74BlCbTbEwTgz26LHQ', 'https://pixersanjgywax.dataplane.rudderstack.com');

      analyticsInstance.ready(() => {
        console.log('We are all set!!!');
      });

      setAnalytics(analyticsInstance);
    }
  }, [analytics]);

  return analytics;
};

export default useRudderStackAnalytics;
